import axios from 'axios';
import { getAuthHeader } from './authApi';

/**
 * Interface representing a Player
 */
export interface Player {
  id: number;
  name: string;
  goals: number;
}

/**
 * Get all players
 */
export const getPlayers = async (): Promise<Player[]> => {
  try {
    const response = await axios.get('/api/players', {
      headers: getAuthHeader()
    });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching players:', error);
    return [];
  }
};

/**
 * Get a player by ID
 */
export const getPlayer = async (id: number): Promise<Player | null> => {
  try {
    const response = await axios.get(`/api/players/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching player ${id}:`, error);
    return null;
  }
};

/**
 * Get players filtered by team ID
 */
export const getPlayersByTeam = async (teamId: number): Promise<Player[]> => {
  try {
    const response = await axios.get(`/api/players?team_id=${teamId}`, {
      headers: getAuthHeader()
    });
    return response.data || [];
  } catch (error) {
    console.error(`Error fetching players for team ${teamId}:`, error);
    return [];
  }
};

/**
 * Search players by name (with optional pagination)
 */
export const searchPlayers = async (query: string, limit = 20, offset = 0): Promise<Player[]> => {
  try {
    const response = await axios.get('/api/players/search', {
      params: { query, limit, offset },
      headers: getAuthHeader()
    });
    return response.data || [];
  } catch (error) {
    console.error('Error searching players:', error);
    return [];
  }
}; 